<template>
  {{ formattedDate }}
</template>

<script>
import intlFormat from 'date-fns/intlFormat'

export default {
  props: {
    date: [Date, String],
  },

  computed: {
    formattedDate () {
      return intlFormat(new Date(this.date), {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })
    },
  },
}
</script>
